import i18n from 'i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import HttpBackend from 'i18next-http-backend';
import { initReactI18next } from 'react-i18next';
import { runtimeConfig } from '@/config/runtime';

export const SUPPORTED_LANGUAGES = ['en', 'de', 'sr'] as const;
export type Language = (typeof SUPPORTED_LANGUAGES)[number];

/** Intl locale per UI language (Serbian = Latin script). */
export const INTL_LOCALE: Record<Language, string> = { en: 'en-GB', de: 'de-DE', sr: 'sr-Latn-RS' };

export function toLanguage(value: string | null | undefined): Language {
  const short = (value ?? '').slice(0, 2).toLowerCase();
  return (SUPPORTED_LANGUAGES as readonly string[]).includes(short) ? (short as Language) : 'en';
}

void i18n
  .use(HttpBackend)
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    supportedLngs: [...SUPPORTED_LANGUAGES],
    nonExplicitSupportedLngs: true,
    load: 'languageOnly',
    fallbackLng: toLanguage(runtimeConfig.defaultLocale),
    ns: ['common', 'menu', 'errors'],
    defaultNS: 'common',
    backend: { loadPath: '/locales/{{lng}}/{{ns}}.json', queryStringParams: { v: runtimeConfig.appVersion } },
    detection: { order: ['querystring', 'localStorage', 'navigator'], lookupQuerystring: 'lang', caches: ['localStorage'] },
    interpolation: { escapeValue: false },
    returnNull: false,
  });

i18n.on('languageChanged', (lng) => {
  document.documentElement.lang = toLanguage(lng);
});

export default i18n;
